import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
import { FormatServerDate, client, errorValidation } from "./service.js";

export async function getPlayers({
    name = '',
    phoneNumber = '',
    namePhoneNumber = '',
    gender = '',
    birthYearType,
    birthYearStart,
    birthYearEnd,
    registerDateType,
    registerDateStart,
    registerDateEnd,
    userStatus,
    subscribeStatus,
    academyStatus,
    classType,
    classStart,
    classEnd,
    matchType,
    matchStart,
    matchEnd,
    sessionType,
    sessionStart,
    sessionEnd,
    isActive,
    serviceActive
}) {
    try {
        let players = await axios.Get({
            url: `${adminUrl}/players`,
            params: {
                name: name || '',
                phoneNumber: phoneNumber || '',
                namePhoneNumber: namePhoneNumber || '',
                gender: gender || '',
                birthYearType: birthYearType || '',
                birthYearStart: birthYearStart || '',
                birthYearEnd: birthYearEnd || '',
                registerDateType: registerDateType || '',
                registerDateStart: registerDateStart || '',
                registerDateEnd: registerDateEnd || '',
                userStatus: userStatus || '',
                subscribeStatus: subscribeStatus || '',
                academyStatus: academyStatus || '',
                classType: classType || '',
                classStart: classStart || '',
                classEnd: classEnd || '',
                matchType: matchType || '',
                matchStart: matchStart || '',
                matchEnd: matchEnd || '',
                sessionType: sessionType || '',
                sessionStart: sessionStart || '',
                sessionEnd: sessionEnd || '',
                isActive: (isActive == true || isActive == false) ? isActive : '',
                serviceActive: (serviceActive == true || serviceActive == false) ? serviceActive : ''
            }
        });

        if (players.statusCode !== 200) {
            return { error: players.message };
        }

        return { data: players.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getPlayersv2({
    name = '',
    phoneNumber = '',
    gender = '',
    birthYearType,
    birthYearStart,
    birthYearEnd,
    registerDateType,
    registerDateStart,
    registerDateEnd,
    userStatus,
    subscribeStatus,
    academyStatus,
    classType,
    classStart,
    classEnd,
    matchType,
    matchStart,
    matchEnd,
    sessionType,
    sessionStart,
    sessionEnd,
    isActive,
    page
}) {
    try {
        let players = await axios.Get({
            url: `${adminUrl}/players-v2`,
            params: {
                name: name || '',
                phoneNumber: phoneNumber || '',
                gender: gender || '',
                birthYearType: birthYearType || '',
                birthYearStart: birthYearStart || '',
                birthYearEnd: birthYearEnd || '',
                registerDateType: registerDateType || '',
                registerDateStart: FormatServerDate(registerDateStart) || '',
                registerDateEnd: registerDateEnd || '',
                userStatus: userStatus || '',
                subscribeStatus: subscribeStatus || '',
                academyStatus: academyStatus || '',
                classType: classType || '',
                classStart: classStart || '',
                classEnd: classEnd || '',
                matchType: matchType || '',
                matchStart: matchStart || '',
                matchEnd: matchEnd || '',
                sessionType: sessionType || '',
                sessionStart: sessionStart || '',
                sessionEnd: sessionEnd || '',
                isActive: (isActive == true || isActive == false) ? isActive : '',
                page: page || 0
            }
        });

        if (players.statusCode !== 200) {
            return { error: players.message };
        }

        return { data: players.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function loadPlayerList({
    namePhoneNumber = ''
}) {
    try {
        let players = await axios.Get({
            url: `${adminUrl}/players-select`,
            params: {
                namePhoneNumber: namePhoneNumber || ''
            }
        });

        if (players.statusCode !== 200) {
            return { error: players.message };
        }

        return { data: players.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getPlayerDetail(id) {
    try {
        let players = await axios.Get({
            url: `${adminUrl}/player/${id}`,
        });

        if (players.statusCode !== 200) {
            return { error: players.message };
        }

        return { data: players.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function updatePlayer(body) {
    try {
        let response = await client.post(`${adminUrl}/player-update`, {
            ...body
        });

        if (response.data.statusCode !== 200) {
            throw response.data
        }

        return { data: response.data };
    } catch (e) {
        return errorValidation(e)
    }
}

export async function getPlayerSession(filter) {
    try {
        let { id, startDate, endDate, entry, dateType, page, limit } = filter
        let sessions = await axios.Get({
            url: `${adminUrl}/session-balance?user=${id}&entry=${entry || ''}&dateType=${dateType || ''}&startDate=${startDate || ''}&endDate=${endDate || ''}&page=${page}&limit=${limit}`,
        });

        if (sessions.statusCode !== 200) {
            return { error: sessions.message };
        }

        return { data: sessions.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getManualOTP(_id) {
    try {
        let response = await axios.Get({
            url: `${adminUrl}/get-otp?user=${_id}`,
        });

        if (response.statusCode !== 200) {
            return { error: response.message };
        }

        return { data: response.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function updateManualOTP(body) {
    try {
        let response = await client.post(`${adminUrl}/player/update-otp`, {
            ...body
        });
        if (response.data.statusCode !== 200) {
            throw response.data
        }
        return { data: response.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getPlayerProfileHistory({
    userId
}) {
    try {
        let response = await client.get(`${adminUrl}/players/profile-history?userId=${userId}`);
        if (response.data.statusCode !== 200) {
            throw response.data
        }
        return { data: response.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getPlayerClass({
    userId,
    dateType, startDate, endDate, className
}) {
    try {
        let response = await client.get(`${adminUrl}/players/classes?userId=${userId || ''}&dateType=${dateType || ''}&startDate=${startDate || ''}&endDate=${endDate || ''}&className=${className || ''}`);
        if (response.data.statusCode !== 200) {
            throw response.data
        }
        return { data: response.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getPlayerSchedule({
    userId, month, year, placeId
}) {
    try {
        let response = await client.get(`${adminUrl}/players/schedule?userId=${userId}&month=${month}&year=${year}&placeId=${placeId}`);
        if (response.data.statusCode !== 200) {
            throw response.data
        }
        return { data: response.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getPlayerCourtSchedule({
    court, date, userId
}) {
    try {
        let response = await client.get(`${adminUrl}/players/court-schedule?userId=${userId}&court=${court}&day=${date}`);
        if (response.data.statusCode !== 200) {
            throw response.data
        }
        return { data: response.data };
    } catch (e) {
        return { error: e.response.data };
    }
}